import {
  addDays,
  differenceInDays,
  formatISO,
  parseISO,
  startOfDay,
  startOfToday,
  startOfYesterday,
} from 'date-fns';

import queryString from 'query-string';

import { GAME_CATEGORIES, GAME_WORDS } from './data';

export const getToday = () => startOfToday();
export const getYesterday = () => startOfYesterday();

// October 2023 Game Epoch
// https://stackoverflow.com/questions/2552483/why-does-the-month-argument-range-from-0-to-11-in-javascripts-date-constructor
export const firstGameDate = new Date(2023, 9, 23);
export const periodInDays = 7;

export const getLastGameDate = (today) => {
  const t = startOfDay(today);
  let daysSinceLastGame = differenceInDays(t, firstGameDate) % periodInDays;
  return addDays(t, -daysSinceLastGame);
};

export const getNextGameDate = (today) => {
  return addDays(getLastGameDate(today), periodInDays);
};

export const isValidGameDate = (date) => {
  if (date < firstGameDate || date > getToday()) {
    return false;
  }

  return differenceInDays(firstGameDate, date) % periodInDays === 0;
};

export const getIndex = (gameDate) => {
  let start = firstGameDate;
  let index = -1;
  do {
    index++;
    start = addDays(start, periodInDays);
  } while (start <= gameDate);

  return index;
};

// Helper to get items from array starting at index, wrapping around
const getItemsWithWrap = (array, startIndex, count) => {
  const items = [];
  for (let i = 0; i < count; i++) {
    items.push(array[(startIndex + i) % array.length]);
  }
  return items;
};

export const getPuzzleOfDay = (index) => {
  if (index < 0) {
    throw new Error('Invalid index');
  }

  // Get 4 categories starting at index, wrapping around
  const categories = getItemsWithWrap(GAME_CATEGORIES, index, 4);

  // Get 16 words starting at index * 4, wrapping around
  const words = getItemsWithWrap(GAME_WORDS, index * 4, 16);

  // Structure as array of category objects for compatibility
  // Words are arbitrarily grouped (4 per category) since correctness is random
  return [
    { category: categories[0], words: words.slice(0, 4), difficulty: 1 },
    { category: categories[1], words: words.slice(4, 8), difficulty: 2 },
    { category: categories[2], words: words.slice(8, 12), difficulty: 3 },
    { category: categories[3], words: words.slice(12, 16), difficulty: 4 },
  ];
};

export const getSolution = (gameDate) => {
  const nextGameDate = getNextGameDate(gameDate);
  const index = getIndex(gameDate);
  const puzzleOfTheDay = getPuzzleOfDay(index);
  console.log('index for today: ', index);
  return {
    puzzleAnswers: puzzleOfTheDay,
    puzzleGameDate: gameDate,
    puzzleIndex: index,
    dateOfNextPuzzle: nextGameDate.valueOf(),
  };
};

export const getGameDate = () => {
  if (getIsLatestGame()) {
    return getToday();
  }

  const parsed = queryString.parse(window.location.search);
  try {
    const d = startOfDay(parseISO(parsed.d?.toString()));
    if (d >= getToday() || d < firstGameDate) {
      setGameDate(getToday());
    }
    return d;
  } catch (e) {
    console.log(e);
    return getToday();
  }
};

export const setGameDate = (d) => {
  try {
    if (d < getToday()) {
      window.location.href = '/?d=' + formatISO(d, { representation: 'date' });
      return;
    }
  } catch (e) {
    console.log(e);
  }
  window.location.href = '/';
};

export const getIsLatestGame = () => {
  // https://github.com/cwackerfuss/react-wordle/pull/505
  const parsed = queryString.parse(window.location.search);
  return parsed === null || !('d' in parsed);
};

export const { puzzleAnswers, puzzleGameDate, puzzleIndex, dateOfNextPuzzle } =
  getSolution(getGameDate());
